import { request } from "../axios/request";

export const getCustomFieldsService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/custom-fields", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const getAllCustomFieldsService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/custom-fields", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const saveCustomFieldService = (data, id = 0) => {
  if (id > 0) {
    return async (dispatch, getState) => {
      return dispatch(
        request("/custom-fields/" + id, getState(), {
          method: "PUT",
          data,
        })
      );
    };
  }
  return async (dispatch, getState) => {
    return dispatch(
      request("/custom-fields", getState(), {
        method: "POST",
        data,
      })
    );
  };
};

export const deleteCustomFieldService = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/custom-fields/" + id, getState(), {
        method: "DELETE",
      })
    );
  };
};
